<template>
    <div>
        <ul class="list-group list-group-flush">
            <li v-for="item,i in lista" :key="`regiao-empresa-${i}`" class="font-size-13 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <i class="fa fa-users mr-2" :class="`text-${item.variante}`"></i>
                    <div class="font-bold" :class="`text-${item.variante}`">{{item.titulo}}:</div>
                </div>
                <span>
                    {{retornarQuantidade(item.prop)}}
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
import DashboardAdminService from "@/common/services/dashboards/dashboard_admin.service";
export default {
    data : () => ({
        dados : [],
        lista : [
            {
                variante : "info",
                titulo : "Centro Oeste",
                prop : "CentroOeste"
            },
            {
                variante : "success",
                titulo : "Nordeste",
                prop : "Nordeste"
            },
            {
                variante : "secondary",
                titulo : "Norte",
                prop : "Norte"
            },
            {
                variante : "warning",
                titulo : "Sudeste",
                prop : "Sudeste"
            },
            {
                variante : "danger",
                titulo : "Sul",
                prop : "Sul"
            }
        ]
    }),
    methods : {
        buscar : function(){
            DashboardAdminService.usuariosPorRegiao().then(response => {
                this.dados = response.data.data;
            })
        },
        retornarQuantidade : function(prop){
            let dados = this.dados.find(el => { 
                return el.regiao == prop;
            });
            return dados ? dados.usuarios.length : 0;
        }
    },
    mounted(){
        this.buscar();
    },
}
</script>
<style lang="">
    
</style>